import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

export const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    height: "100%",
    width: "100%",
    padding: `${designTokens.spacing[10]} ${designTokens.spacing[5]} 0`,
    boxSizing: "border-box",
    backgroundColor: designTokens.neutral[50],
    fontFamily: designTokens.fontFamily,
    overflowY: "auto",
    "@media (max-width: 480px)": {
      padding: `${designTokens.spacing[5]} ${designTokens.spacing[4]} 0`,
    },
  },
  contentWrapper: {
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[5],
    width: "100%",
    maxWidth: "660px",
  },
  title: {
    fontWeight: designTokens.fontWeight.bold,
    fontSize: designTokens.fontSize["2xl"],
    color: designTokens.primary[900],
    margin: 0,
    marginBottom: designTokens.spacing[8],
    lineHeight: designTokens.lineHeight.tight,
    textAlign: "center",
    "@media (max-width: 480px)": {
      fontSize: designTokens.fontSize.xl,
      marginBottom: designTokens.spacing[5],
    },
  },
  beginningMessage: {
    fontSize: designTokens.fontSize.base,
    lineHeight: designTokens.lineHeight.relaxed,
    color: designTokens.neutral[700],
    whiteSpace: "pre-line",
    margin: 0,
    textAlign: "left",
  },
  collapsibleSection: {
    borderRadius: designTokens.borderRadius.lg,
    border: `1px solid ${designTokens.neutral[200]}`,
    overflow: "hidden",
    backgroundColor: designTokens.neutral.white,
  },
  collapsibleTrigger: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    backgroundColor: designTokens.neutral[50],
    border: "none",
    cursor: "pointer",
    paddingTop: designTokens.spacing[3],
    paddingBottom: designTokens.spacing[3],
    paddingLeft: designTokens.spacing[5],
    paddingRight: designTokens.spacing[5],
    fontFamily: designTokens.fontFamily,
    fontSize: designTokens.fontSize.sm,
    fontWeight: designTokens.fontWeight.semibold,
    lineHeight: designTokens.lineHeight.normal,
    color: designTokens.neutral[700],
    textAlign: "left",
    transition: `background-color ${designTokens.transition.fast}`,
    ":active": {
      transform: "none",
    },
    ":hover": {
      backgroundColor: designTokens.neutral[100],
    },
    ":focus": {
      outline: `2px solid ${designTokens.accent[500]}`,
      outlineOffset: "2px",
    },
    ":focus:not(:focus-visible)": {
      outline: "none",
    },
    ":focus-visible": {
      outline: `2px solid ${designTokens.accent[500]}`,
      outlineOffset: "2px",
    },
  },
  instructionsContent: {
    paddingTop: designTokens.spacing[5],
    paddingBottom: designTokens.spacing[5],
    paddingLeft: designTokens.spacing[5],
    paddingRight: designTokens.spacing[5],
    borderTop: `1px solid ${designTokens.neutral[200]}`,
    backgroundColor: designTokens.neutral.white,
    textAlign: "left",
    fontSize: designTokens.fontSize.sm,
    lineHeight: designTokens.lineHeight.relaxed,
    color: designTokens.neutral[700],
  },
  subheading: {
    marginTop: designTokens.spacing[4],
    marginBottom: designTokens.spacing[2],
    fontSize: designTokens.fontSize.xs,
    fontWeight: designTokens.fontWeight.semibold,
    color: designTokens.neutral[700],
    textTransform: "uppercase",
    letterSpacing: designTokens.letterSpacing.tight,
  },
  bottomSection: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: designTokens.spacing[4],
    marginTop: "auto",
    width: "100%",
    maxWidth: "660px",
    paddingTop: designTokens.spacing[5],
    "@media (max-width: 640px)": {
      paddingTop: designTokens.spacing[4],
      paddingBottom: designTokens.spacing[4],
      borderTop: `1px solid ${designTokens.neutral[200]}`,
      maxWidth: "100%",
    },
  },
  acceptTermsText: {
    fontSize: designTokens.fontSize.sm,
    lineHeight: designTokens.lineHeight.normal,
    fontWeight: designTokens.fontWeight.semibold,
    color: designTokens.neutral[700],
    textAlign: "center",
    margin: 0,
  },
  linksContainer: {
    display: "flex",
    gap: designTokens.spacing[3],
    justifyContent: "center",
    flexWrap: "wrap",
    alignItems: "center",
    fontSize: designTokens.fontSize.sm,
    color: designTokens.neutral[500],
  },
  linksSeparator: {
    color: designTokens.neutral[300],
    userSelect: "none",
  },
  collapsibleTriggerLabel: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[2],
  },
  actionButtonsContainer: {
    display: "flex",
    gap: designTokens.spacing[3],
    justifyContent: "center",
    "@media (max-width: 480px)": {
      flexDirection: "column-reverse",
      alignItems: "stretch",
      width: "100%",
    },
  },
});
